<div class="card">
  <div class="grid flex-column">
    <div class="mb-3">
      <p-tabMenu [model]="items"></p-tabMenu>
    </div>
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
